import React from 'react';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  homePageAdditionalMeta,
  homePageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import HomePageHeader from '../../components/home/HomePageHeader';

const HomePage = React.memo(() => {

  return (
    <>
      <HelmetItem
        PageName='Home'
        desc={`Enter the realm of ${CompanyName}, where dominance, seduction, and surrender intertwine. Discover My mastery, desires, and the unforgettable experiences that await you.`}
        keywords={KeywordsPages}
        additionalMeta={homePageAdditionalMeta}
        structuredData={homePageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour2 text-colour1 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <div className='grid min-h-screen max-h-screen bg-neonGoth bg-center bg-no-repeat bg-cover'>
            <div className='fixed grid w-full z-max'>
              <Navbar />
            </div>

            {/* Header */}
            <HomePageHeader />
          </div>
          {/* Main page content */}
          <HomePageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
});

export default HomePage;
